import React, { useEffect, useState } from "react";
import "./Section3.css";
import Icons from "../../../../../Config/Images";
import { be } from "date-fns/locale";

// const benefitsData = [
//   {
//     title: "Calculated Weather",
//     content: "Built Wicket longer admire do barton vanity itself do in it.",
//   },
//   {
//     title: "Calculated Weather",
//     content: "Built Wicket longer admire do barton vanity itself do in it.",
//   },
//   {
//     title: "Calculated Weather",
//     content: "Built Wicket longer admire do barton vanity itself do in it.",
//   },
//   {
//     title: "Calculated Weather",
//     content: "Built Wicket longer admire do barton vanity itself do in it.",
//   },
// ];

const Section3 = ({ benifitsMember }) => {
  const [benefitsData, setBenefitsdata] = useState([]);

  useEffect(() => {
    if (benifitsMember?.length > 0) {
      setBenefitsdata(benifitsMember);
    }
  }, [benifitsMember]);
  return (
    <div className="section-3">
      <p className="section-3-header">Benefit to Become Member</p>
      <div className="benefits-div">
        {benefitsData?.map((benefit, index) => (
          <div className="individual-benefit" key={index}>
            <img
              src={
                benefit?.benefit_image
                  ? benefit?.benefit_image
                  : Icons?.default_image
              }
            />
            <div className="benefit-content-div">
              <p className="benefit-para">{benefit?.partner_benefit_text}</p>
              <p className="benefit-content">{benefit?.partner_benefit_content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Section3;
